if (!customElements.get('wt-benefits-product')) {
  customElements.define(
    'wt-benefits-product',
    class WtBenefitsProduct extends HTMLElement {
      connectedCallback () {
        this.imageWrapper = this.querySelector('.wt-benefits-product__img')
        this.iconItems = this.querySelectorAll('.wt-benefits-product__item')

        if (!this.imageWrapper || !this.iconItems.length) return

        try {
          this.images = JSON.parse(
            this.querySelector('[data-benefit-images]')?.textContent || '[]',
          )
        } catch (error) {
          this.images = []
        }

        this.onIconInteract = this.onIconInteract.bind(this)
        this.onVariantChange = this.onVariantChange.bind(this)

        this.iconItems.forEach((item) => {
          item.addEventListener('mouseenter', this.onIconInteract)
          item.addEventListener('click', this.onIconInteract)
        })

        document.addEventListener('variantChangeEnd', this.onVariantChange)

        // variant-options.initialize() runs without dispatching an event, so
        // sync with the initially selected variation once the picker is ready.
        customElements.whenDefined('variant-options').then(() => {
          const picker = document.querySelector('variant-options')
          if (!picker) return
          requestAnimationFrame(() => {
            this.updateForVariant(
              picker.options || this.readOptions(picker),
              picker.currentVariant,
            )
          })
        })
      }

      readOptions (picker) {
        return Array.from(picker.querySelectorAll('.wt-product__option')).map(
          (fieldset) =>
            Array.from(fieldset.querySelectorAll('input')).find(
              (radio) => radio.checked,
            )?.value || '',
        )
      }

      onVariantChange (event) {
        const picker = event.target
        if (!picker || typeof picker.querySelectorAll !== 'function') return
        this.updateForVariant(
          picker.options || this.readOptions(picker),
          picker.currentVariant,
        )
      }

      // Same rules as filterSlidesByOptions in gallery.js: no hashtags in the
      // alt -> always shown, #all -> always shown, "|" separates alternates,
      // every tag must match one of the selected option values.
      matchesOptions (alt, options) {
        const lowercaseOptions = options.map((option) =>
          option.toLowerCase().replace(/\s/g, ''),
        )
        const altHashtags = (alt?.match(/#[^\s#]+/g) || []).map((hashtag) =>
          hashtag.slice(1).toLowerCase(),
        )

        if (altHashtags.length === 0) return true
        if (altHashtags.some((tag) => tag.split('|').includes('all'))) return true

        return altHashtags.every((tag) =>
          tag
            .split('|')
            .some((variant) => lowercaseOptions.includes(variant.trim())),
        )
      }

      updateForVariant (options, currentVariant) {
        if (!this.images?.length) return

        let filtered = this.images.filter((image) =>
          this.matchesOptions(image.alt || '', options || []),
        )
        if (!filtered.length) filtered = this.images

        const lastFour = filtered.slice(-4)

        this.iconItems.forEach((item) => {
          const slot = Number(item.getAttribute('data-benefit-slot'))
          if (!slot) return

          const image =
            slot === 4 ? lastFour[lastFour.length - 1] : lastFour[slot - 1]
          if (!image) return

          item.setAttribute('data-hero-src', image.hero)
          const thumb = item.querySelector('.wt-benefits-product__item-img img')
          if (thumb && thumb.getAttribute('src') !== image.thumb) {
            thumb.removeAttribute('srcset')
            thumb.setAttribute('src', image.thumb)
          }
        })

        const featuredSrc = currentVariant?.featured_media?.preview_image?.src
        if (featuredSrc) {
          this.updateHeroImage(this.withWidth(featuredSrc, 1200))
        } else {
          this.restoreHeroImage()
        }
      }

      withWidth (src, width) {
        return `${src}${src.includes('?') ? '&' : '?'}width=${width}`
      }

      onIconInteract (event) {
        const item = event.currentTarget
        const heroSrc = item.getAttribute('data-hero-src')

        if (!heroSrc) return

        this.updateHeroImage(heroSrc)
      }

      updateHeroImage (src) {
        const existingImg = this.imageWrapper.querySelector(
          'img.wt-benefits-product__hero',
        )

        if (existingImg) {
          if (existingImg.getAttribute('src') === src) return

          existingImg.setAttribute('src', src)
          existingImg.removeAttribute('srcset')
          return
        }

        const img = document.createElement('img')
        img.className = 'wt-benefits-product__hero'
        img.src = src
        img.alt = ''
        img.loading = 'lazy'

        // Hide the default media but keep the CTA button intact.
        this.defaultHeroMedia = Array.from(this.imageWrapper.children).filter(
          (el) => !el.classList.contains('wt-benefits-product__btn-wrapper'),
        )
        this.defaultHeroMedia.forEach((el) => {
          el.style.display = 'none'
        })
        this.imageWrapper.prepend(img)
      }

      restoreHeroImage () {
        const hero = this.imageWrapper.querySelector(
          'img.wt-benefits-product__hero',
        )
        if (!hero) return

        hero.remove()
        this.defaultHeroMedia?.forEach((el) => {
          el.style.display = ''
        })
      }

      disconnectedCallback () {
        this.iconItems?.forEach((item) => {
          item.removeEventListener('mouseenter', this.onIconInteract)
          item.removeEventListener('click', this.onIconInteract)
        })
        document.removeEventListener('variantChangeEnd', this.onVariantChange)
      }
    },
  )
}
